import { call, put, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import errorHandler from "common/errorHandler";
import * as actions from "./actions";

// No tenantid header — the tenant is determined server-side from the auth-token claims.

export function* getSurIdDetailsRequest(api, action) {
    try {
        const { surId } = action.params;
        const result = yield call([api, api.get], `${Endpoints.duplicates}/api/v1/dataobjects/surid/${surId}`);
        yield put(actions.getSurIdDetailsSuccess(result.data));
    } catch (error) {
        yield put(actions.getSurIdDetailsFailure(errorHandler(error, "Get", "golden record id (SURID)")));
    }
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_SURID_DETAILS_REQUEST, getSurIdDetailsRequest, api);
}
